import { useMemo } from 'react';

import { useScreenState } from '@gogame/screens';

export const useCurrentDimension = () => {
  const screenState = useScreenState();

  return useMemo(() => {
    return ([...screenState.drillPath].pop() || {}).type;
  }, [screenState.drillPath]);
};
